import { createContext } from 'react';

const AppContext = createContext({
    rulesList: [],
    connections: [],
    integrations: [],
    isAdmin: false,
    profileEnabled: true,
});

export default AppContext;